import { FC, useState, useMemo, useEffect } from 'react';
import SidebarFilter from '../../SidebarFilter/SidebarFilter';
import { useForm } from 'react-hook-form';
import { Col, Form, Row } from 'react-bootstrap';
import ReactSelect from 'react-select';
import { useProductivityDashboard } from '../../../providers/Dashboards/ProductivityDashboardProvider';
import { useSidebarFilter } from '../../../providers/SidebarFilterProvider';
import { customStyles } from '../../../models/SelectCustomStyles';


const SidebarProductivityDashboardFilter: FC = () => {
  const { handleSubmit, reset, setValue } = useForm<any>({
    defaultValues: {
      period: '',
      collaborator_id: '',
      category_id: '',
      start_date: '',
      end_date: '',
    }
  });
  const { setFilters, collaborators = [], categories = [] } = useProductivityDashboard();
  const { setShowSidebarFilter } = useSidebarFilter();

  const [selectedPeriod, setSelectedPeriod] = useState<any>(null);
  const [selectedCollaborator, setSelectedCollaborator] = useState<any>(null);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleDateChange = (value: string, isStartDate: boolean) => {
    if (isStartDate) {
      setStartDate(value || '');
    } else {
      setEndDate(value || '');
    }
    if (value) {
      setSelectedPeriod(null);
      setValue('period', '');
    }
  };

  const periodOptions = useMemo(() => [
    { label: 'Hoje', value: 'day' },
    { label: 'Últimos 7 dias', value: 'week' },
    { label: 'Este Mês', value: 'month' },
    { label: 'Últimos 60 dias', value: 'last_60_days' },
    { label: 'Últimos 90 dias', value: 'last_90_days' },
    { label: 'Este Ano', value: 'year' },
  ], []);


  const collaboratorsOptions = useMemo(() =>
    collaborators.map((c: any) => ({ label: c.name, value: c.id })) || [],
    [collaborators]
  );

  const categoriesOptions = useMemo(() =>
    categories.map((c: any) => ({ label: c.name, value: c.id })) || [],
    [categories]
  );

  const onSubmit = async () => {
    const hasDates = startDate || endDate;
    const newFilters = {
      collaborator_id: selectedCollaborator?.value || null,
      period: hasDates ? null : (selectedPeriod?.value || null),
      start_date: startDate || null,
      end_date: endDate || null,
      category_id: selectedCategory?.value || null,
    };

    setFilters(newFilters);
    setShowSidebarFilter(false);
  };

  const handleClear = () => {
    reset({
      period: '',
      collaborator_id: '',
      category_id: '',
    });
    setSelectedPeriod(null);
    setSelectedCollaborator(null);
    setSelectedCategory(null);
    setStartDate('');
    setEndDate('');
    setFilters({
      collaborator_id: null,
      period: null,
      start_date: null,
      end_date: null,
      category_id: null,
    });
  };

  return (
    <SidebarFilter
      handleSubmit={handleSubmit(onSubmit)}
      handleClear={handleClear}
    >
      <div className="SidebarProductivityDashboardFilter" data-testid="SidebarProductivityDashboardFilter">
        <Row className="mt-1">
          <Col>
            <Form.Group>
              <Form.Label className="dashboard-filters__label">Período</Form.Label>
              <ReactSelect
                isSearchable
                isClearable
                options={periodOptions}
                value={selectedPeriod}
                placeholder="Selecione"
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => {
                  setSelectedPeriod(e);
                  setValue('period', e?.value || '');
                  setStartDate('');
                  setEndDate('');
                }}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mt-2">
          <Col>
            <Form.Group>
              <Form.Label className="dashboard-filters__label">Colaborador</Form.Label>
              <ReactSelect
                isSearchable
                isClearable
                options={collaboratorsOptions}
                value={selectedCollaborator}
                placeholder="Selecione"
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => {
                  setSelectedCollaborator(e);
                  setValue('collaborator_id', e?.value || '');
                }}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mt-2">
          <Col>
            <Form.Group>
              <Form.Label className="dashboard-filters__label">Categoria</Form.Label>
              <ReactSelect
                isSearchable
                isClearable
                options={categoriesOptions}
                value={selectedCategory}
                placeholder="Selecione"
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => {
                  setSelectedCategory(e);
                  setValue('category_id', e?.value || '');
                }}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mt-2">
          <Col>
            <Form.Group>
              <Form.Label className="dashboard-filters__label">Data Início</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => handleDateChange(e.target.value, true)}
                className="form-control"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mt-2">
          <Col>
            <Form.Group>
              <Form.Label className="dashboard-filters__label">Data Fim</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => handleDateChange(e.target.value, false)}
                className="form-control"
              />
            </Form.Group>
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
};

export default SidebarProductivityDashboardFilter;
